import api from '../../../../api';

export const Inventory = {
  accordion: api.internals.ns.selector('accordion'),
  alert: api.internals.ns.selector('alert'),
  badge: api.internals.ns.selector('badge'),
  breadcrumb: api.internals.ns.selector('breadcrumb'),
  button: api.internals.ns.selector('btn'),
  callout: api.internals.ns.selector('callout'),
  card: api.internals.ns.selector('card'),
  checkbox: api.internals.ns.selector('checkbox-group'),
  connect: api.internals.ns.selector('connect'),
  consent: api.internals.ns.selector('consent-banner'),
  content: api.internals.ns.selector('content-media'),
  download: api.internals.ns.selector('download'),
  follow: api.internals.ns.selector('follow'),
  footer: api.internals.ns.selector('footer'),
  header: api.internals.ns.selector('header'),
  highlight: api.internals.ns.selector('highlight'),
  input: api.internals.ns.selector('input-group'),
  link: api.internals.ns.selector('link'),
  modal: api.internals.ns.selector('modal'),
  navigation: api.internals.ns.selector('nav'),
  notice: api.internals.ns.selector('notice'),
  pagination: api.internals.ns.selector('pagination'),
  quote: api.internals.ns.selector('quote'),
  radio: api.internals.ns.selector('radio-group'),
  search: api.internals.ns.selector('search-bar'),
  select: api.internals.ns.selector('select'),
  share: api.internals.ns.selector('share'),
  sidemenu: api.internals.ns.selector('sidemenu'),
  stepper: api.internals.ns.selector('stepper'),
  summary: api.internals.ns.selector('summary'),
  tab: api.internals.ns.selector('tabs'),
  table: api.internals.ns.selector('table'),
  tag: api.internals.ns.selector('tag'),
  tile: api.internals.ns.selector('tile'),
  toggle: api.internals.ns.selector('toggle'),
  tooltip: api.internals.ns.selector('tooltip'),
  transcription: api.internals.ns.selector('transcription'),
  translate: api.internals.ns.selector('translate'),
  upload: api.internals.ns.selector('upload-group')
};
